import { render } from "./VendingMachineByVendor.vue?vue&type=template&id=5b3f8e7a"
import script from "./VendingMachineByVendor.vue?vue&type=script&lang=js"
export * from "./VendingMachineByVendor.vue?vue&type=script&lang=js"
script.render = render

export default script